/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createJingleCollectionModelSchema } from "../createJingleCollectionModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

/**
 * @description Идентификатор созданной подборки
 */
export const postApiJingleCollections200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Подборка уже существует
 */
export const postApiJingleCollections400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiJingleCollections401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiJingleCollections403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiJingleCollections500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiJingleCollectionsMutationRequestSchema = z.lazy(() => createJingleCollectionModelSchema).describe("Тело запроса")

export const postApiJingleCollectionsMutationResponseSchema = z.lazy(() => postApiJingleCollections200Schema)